<template>
  <b-container
    id="calendar"
    fluid
  >
    <b-card>
      <full-calendar
        ref="refCalendar"
        :options="calendarOptions"
        class="full-calendar"
      />
    </b-card>
  </b-container>
</template>

<script>
/* eslint-disable global-require */
import {
  BContainer,
  BCard,
  // VBToggle,
} from 'bootstrap-vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import ptLocale from '@fullcalendar/core/locales/pt-br'

export default {
  components: {
    FullCalendar,
    BContainer,
    BCard,
  },
  directives: {
    // 'b-toggle': VBToggle,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin, momentTimezonePlugin],
        initialView: 'dayGridMonth',
        locale: ptLocale,
        headerToolbar: {
          start: 'sidebarToggle, prev,next, title',
          end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth',
        },
        // dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        events: this.events,
      },
    }
  },
  computed: {
  },
  watch: {
    events(target) {
      this.calendarOptions.events = target
    },
  },
  methods: {
    // handleDateClick(arg) {
    //   console.log(`date click! ${arg.dateStr}`)
    // },
    handleEventClick(arg) {
      this.$emit('calendar-event-click', arg.event)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
@import '@core/scss/vue/pages/page-misc.scss';

.paused {
  font-weight: bold;
  font-family: math;
}

.time-to-refresh {
  width: 75px
}
</style>
